import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";
import { GetPaymentResponse } from "../types/Payments";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const payoutApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({

    getPayout: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
        status: string;
      }
    >({
      query: ({ from, size, search, status }) => ({
        url:
          `${END_POINTS.payout}?from=${from}&status=${status}&size=${size}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getPayment: builder.query<
      GetPaymentResponse,
      {
        from: number;
        size: number;
        search: string;
      }
    >({
      query: ({ from, size, search }) => ({
        url:
          `${END_POINTS.getPayment}?from=${from}&size=${size}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getBannerDetail: builder.query<
      CommonResponseType & {
        data: any;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.banner}/${id}`,
        method: "GET",
      }),
    }),
    updatePayout: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updatePayout}/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetPayoutQuery,
  useUpdatePayoutMutation,
  useLazyGetPaymentQuery
} = payoutApi;
